'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by Administrator on 2016/7/5.
                                          */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _servicesMarket = require('redux/modules/servicesMarket');

var _reduxAsyncConnect = require('redux-async-connect');

var _background = require('redux/modules/background');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { Link } from 'react-router';

var ServicesHomePage = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    var location = _ref.location;

    var promises = [];
    var currentQuery = {};
    var locationQuery = location.query;
    var page = null;
    if (locationQuery) {
      if (locationQuery.type) {
        currentQuery.serviceType = locationQuery.type;
      }
      if (locationQuery.findValue) {
        currentQuery.FindValue = locationQuery.findValue;
      }
      if (locationQuery.page) {
        page = locationQuery.page;
      }
    }
    promises.push(dispatch((0, _background.changeHeaderText)('行业服务')));
    promises.push(dispatch((0, _servicesMarket.load)(currentQuery, page)));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    initialInfo: state.servicesMarket.initialInfo,
    data: state.servicesMarket.data,
    servicesError: state.servicesMarket.error
  };
}, {
  routerPush: _reactRouterRedux.push
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ServicesHomePage, _Component);

  function ServicesHomePage() {
    (0, _classCallCheck3.default)(this, ServicesHomePage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ServicesHomePage).call(this));

    _this.state = {
      serviceBtnFlipped: null
    };
    return _this;
  }

  (0, _createClass3.default)(ServicesHomePage, [{
    key: 'onItemClick',
    value: function onItemClick(val) {
      var _props = this.props;
      var routerPush = _props.routerPush;
      var location = _props.location;

      if (routerPush) {
        if (val) {
          routerPush({ pathname: location.pathname, query: { type: val } });
        } else {
          routerPush({ pathname: location.pathname, query: {} });
        }
        // this.scrollToAnchor('onMiddleNavFilter');
      }
    }
  }, {
    key: 'onOrderItemClick',
    value: function onOrderItemClick(val) {
      var _props2 = this.props;
      var routerPush = _props2.routerPush;
      var location = _props2.location;

      switch (val) {
        case 'zw':
          break;
        default:
          if (routerPush) {
            var query = {};
            if (location.query.type) {
              query.type = location.query.type;
            }
            routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, query) });
          }
      }
    }
  }, {
    key: 'onPageItemClick',
    value: function onPageItemClick(page) {
      var _props3 = this.props;
      var routerPush = _props3.routerPush;
      var location = _props3.location;

      if (routerPush) {
        routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, location.query, { page: page }) });
        this.scrollToAnchor('homePageOrderBar');
      }
    }
  }, {
    key: 'onSearch',
    value: function onSearch(val) {
      var _props4 = this.props;
      var routerPush = _props4.routerPush;
      var location = _props4.location;

      if (routerPush) {
        routerPush({ pathname: location.pathname, query: { findValue: val } });
      }
    }
  }, {
    key: 'scrollTop',
    value: function scrollTop(sTop) {
      window.scrollTo(0, sTop);
    }
  }, {
    key: 'scrollToAnchor',
    value: function scrollToAnchor(anchorName) {
      if (anchorName) {
        var anchorElement = document.getElementById(anchorName);
        if (anchorElement) {
          anchorElement.scrollIntoView();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var data = this.props.data;

      var middleImages = ['http://tupian.goeasy.cn:9999/yipinwang/third/mfw_icon_a.png', 'http://tupian.goeasy.cn:9999/yipinwang/third/mfw_icon_b.png'];
      /*    const orderArray = [
       {id: 'zw', text: ''},
       {id: 'zw', text: ''},
       {id: 'zw', text: ''},
       {id: 'zw', text: ''},
       {id: 'zw', text: ''},
       {id: 'zw', text: ''}
       ]; */
      var carouselDiv = '';
      var servicesDiv = '';
      var totalPageNumber = 1;
      if (data) {
        var servicesMarketList = data.servicesMarketList;
        var servicesMarketListError = data.servicesMarketListError;
        var servicesMarketListRecordCount = data.servicesMarketListRecordCount;
        var servicesMarketListPagesize = data.servicesMarketListPagesize;
        var servicesMarkeCarousel = data.servicesMarkeCarousel;
        var servicesMarkeCarouselError = data.servicesMarkeCarouselError;

        if (servicesMarkeCarouselError) {
          carouselDiv = '错误：' + servicesMarkeCarouselError;
        } else if (servicesMarkeCarousel instanceof Array) {
          carouselDiv = _react2.default.createElement(_components.GoeasyCarousel, { page: 'productList', images: servicesMarkeCarousel });
        }
        if (servicesMarketListError) {
          servicesDiv = '错误：' + servicesMarketListError;
        } else if (servicesMarketList instanceof Array) {
          servicesDiv = _react2.default.createElement(
            'ul',
            { style: { width: '100%' } },
            servicesMarketList.map(function (service, index) {
              return _react2.default.createElement(_components.ServiceInfo, { key: service.id, index: index, service: service });
            })
          );
        }
        totalPageNumber = parseInt(servicesMarketListRecordCount / servicesMarketListPagesize, 10);
        if (servicesMarketListRecordCount % servicesMarketListPagesize > 0) {
          ++totalPageNumber;
        }
      }
      // const orderArray = [ '产品分类', '综合指数', '艺品合作', '信用', '人气', '销量', '评价' ];
      return _react2.default.createElement(
        'div',
        null,
        carouselDiv,
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.HomePageSearchBar, { placeholderTexts: '请输入服务商名称\\关键字', onSearch: this.onSearch.bind(this) }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement('a', { id: 'onMiddleNavFilter' }),
        _react2.default.createElement(_components.ServiceMarketMiddleFilterItem, { onItemClick: this.onItemClick.bind(this) }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.ListPageMiddleFlip, { data: middleImages }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement('a', { id: 'homePageOrderBar' }),
        _react2.default.createElement('div', { className: 'clear' }),
        servicesDiv,
        _react2.default.createElement('div', { className: 'clear' }),
        totalPageNumber && totalPageNumber > 1 ? _react2.default.createElement(_components.HomePagingBar, { totalPageNumber: totalPageNumber, onPageItemClick: this.onPageItemClick.bind(this) }) : '',
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return ServicesHomePage;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object,
  location: _react.PropTypes.object,
  servicesError: _react.PropTypes.string,
  routerPush: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = ServicesHomePage;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ServicesHomePage/ServicesHomePage.js
 ** module id = 1540
 ** module chunks = 0
 **/